<template>
  <div>
    <EventForm
      title="Watch event recording"
      :subtitle="subtitle"
      submit-text="Watch Now"
      :on-apply-now="toggleApplyNowModal"
      :on-submit="onSubmit"
      :no-inputs="eventsEmailExists"
      :past-event="true"
    />
    <Modals
      :toggle-apply-now="toggleApplyNowModal"
      :toggle-success="toggleSuccessModal"
      :show-apply-now="showApplyNowModal"
      :show-success="showSuccessModal"
    />
  </div>
</template>

<script>
import EventForm from '../EventForm/EventForm';
import Modals from '../Modals/Modals.vue';

export default {
  components: {
    EventForm,
    Modals,
  },
  props: {
    eventLink: {
      type: String,
      required: true,
    },
    eventId: {
      type: Number,
      required: true,
    },
    eventPrivate: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['email-joined'],
  data() {
    return {
      showApplyNowModal: false,
      showSuccessModal: false,
      eventsEmailExists: true,
    };
  },
  computed: {
    subtitle() {
      return this.eventPrivate
        ? 'This is an exclusive event for Proxify members.'
        : '';
    },
  },
  mounted() {
    this.eventsEmailExists =
      this.$localStorage.getItem('events_email') !== null;
  },
  methods: {
    toggleApplyNowModal() {
      this.showApplyNowModal = !this.showApplyNowModal;
    },
    toggleSuccessModal() {
      this.showSuccessModal = !this.showSuccessModal;
    },
    async onSubmit(email) {
      try {
        this.$analytics.track('CTA Clicked', {
          cta_name: 'Watch now',
          page_name: 'Event_page',
        });

        await this.$cmsApi.post(`/events/${this.eventId}/register`, { email });
        this.setEmailEligible(email);
      } catch (error) {
        if (error.response.status === 401) {
          this.toggleApplyNowModal();
        } else if (error.response.status === 409) {
          this.setEmailEligible(email);
        }
      }
    },
    setEmailEligible(email) {
      this.$localStorage.setItem('events_email', email);
      this.$emit('email-joined');
      this.eventsEmailExists = true;

      window.open(this.eventLink, '_blank');
    },
  },
};
</script>

<style></style>
